import React from 'react';
import { MasterSheetEdit as V2MasterSheetEdit } from '../../master-sheet-v2/views';
import { DRYWALL_CONFIG } from '../../master-sheet-v2/config';

export const MasterSheetEdit: React.FC = () => (
  <V2MasterSheetEdit config={DRYWALL_CONFIG} />
);
